module.exports = __webpack_public_path__ + "img/arrecredi_banner_1.4f1d1e9a.webp";